import { ReactElement } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import { useToken } from '../hooks/useToken';
import { AppBootstrap } from './AppBootstrap';

/**
 * Gate for protected routes: when TokenGate has no access token it redirects to
 * /login; otherwise it mounts AppBootstrap (app-init + AuthContext) around the
 * authenticated app. This prevents App/useAuth from mounting without AuthContext.
 */
export function RequireAuth({ children }: { children: ReactElement }) {
  const token = useToken();
  const { pathname, search } = useLocation();

  if (!token) {
    const current = pathname + search;
    const to =
      current && current !== '/' ? `/login?redirect_to=${encodeURIComponent(current)}` : '/login';

    return <Redirect to={to} />;
  }

  return <AppBootstrap>{children}</AppBootstrap>;
}
